export const auth = {
  Login: "Login",
  Logout: "Logout",
  Register: "Register",
  ChangeUserInfo: "Change User Info",
} as const;
